import { useEffect, useRef, useState } from 'react';

export const useMediaQuery = (query: string) => {
    const watcher = useRef(window.matchMedia(query));
    const [isMatched, setIsMatched] = useState(true);

    useEffect(() => {
        const handleChange = () => {
            setIsMatched(watcher.current.matches);
        };

        watcher.current.addEventListener('change', handleChange);

        handleChange();

        return () => {
            watcher.current?.removeEventListener('change', handleChange);
        };
    }, []);

    return isMatched;
};
